import { format } from 'date-fns';
import { DEFAULT_GEO_INSIGHTS_DAYS, DEFAULT_GEO_PROMPTS_DAYS } from './geoConstants';
import { parseMultiSelect } from '../../../utils/filtersApi';

export const GEO_FILTER_DEFAULTS = {
  insightsDays: DEFAULT_GEO_INSIGHTS_DAYS,
  promptsDays: DEFAULT_GEO_PROMPTS_DAYS,
  useCustomRange: false,
  competitors: 'All competitors',
  sentimentType: 'all',
};

export const GEO_COMPETITORS_DEFAULT = GEO_FILTER_DEFAULTS.competitors;

export function parseIsoDateLocal(iso) {
  if (!iso) return null;
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return null;
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function datesToIso(start, end) {
  const from = start ? format(start, 'yyyy-MM-dd') : null;
  const to = end ? format(end, 'yyyy-MM-dd') : null;
  return { from, to };
}

export function getGeoCompetitorSelections(filterCompetitors, catalog = []) {
  const selected = parseMultiSelect(filterCompetitors, GEO_COMPETITORS_DEFAULT, catalog);
  return {
    selectedCompetitors: selected,
    allCompetitorsSelected: selected.length === 0,
  };
}

export function buildGeoInsightsParams({
  days,
  useCustomRange,
  dateFrom,
  dateTo,
  filterCompetitors,
  competitorCatalog = [],
}) {
  const { selectedCompetitors, allCompetitorsSelected } = getGeoCompetitorSelections(
    filterCompetitors,
    competitorCatalog,
  );

  const params = {};

  if (useCustomRange && dateFrom && dateTo) {
    const { from, to } = datesToIso(dateFrom, dateTo);
    if (from) params.from = from;
    if (to) params.to = to;
  } else {
    params.days = days;
  }

  if (!allCompetitorsSelected) {
    params.competitors = selectedCompetitors.join(',');
  }

  return params;
}

export function buildGeoPromptsParams({
  page,
  pageSize,
  searchTerm,
  sentimentType,
  days = DEFAULT_GEO_PROMPTS_DAYS,
  useCustomRange = false,
  dateFrom = null,
  dateTo = null,
}) {
  const params = {
    page,
    pageSize,
  };

  const search = String(searchTerm || '').trim();
  if (search) {
    params.search = search;
  }

  if (sentimentType && sentimentType !== 'all') {
    params.sentiment = sentimentType;
  }

  if (useCustomRange && dateFrom && dateTo) {
    const { from, to } = datesToIso(dateFrom, dateTo);
    if (from) params.from = from;
    if (to) params.to = to;
  } else {
    params.days = days;
  }

  return params;
}

export function hasGeoInsightsFiltersApplied({
  days,
  useCustomRange,
  dateFrom,
  dateTo,
  filterCompetitors,
  competitorCatalog = [],
} = {}) {
  if (useCustomRange) {
    if (dateFrom || dateTo) return true;
  } else if (Number(days) !== DEFAULT_GEO_INSIGHTS_DAYS) {
    return true;
  }

  const { allCompetitorsSelected } = getGeoCompetitorSelections(filterCompetitors, competitorCatalog);
  if (!allCompetitorsSelected) return true;

  return false;
}

export function hasGeoPromptsFiltersApplied({
  days,
  useCustomRange,
  dateFrom,
  dateTo,
  searchTerm,
  sentimentType,
} = {}) {
  if (useCustomRange) {
    if (dateFrom || dateTo) return true;
  } else if (Number(days) !== DEFAULT_GEO_PROMPTS_DAYS) {
    return true;
  }
  if (Boolean(String(searchTerm || '').trim())) return true;
  if (sentimentType !== GEO_FILTER_DEFAULTS.sentimentType) return true;
  return false;
}

export function matchesGeoPromptSearch(row, term) {
  if (!term) return true;
  const q = term.toLowerCase();
  return [row.queryId, row.prompt].some((field) => String(field || '').toLowerCase().includes(q));
}
